<script setup lang="ts">
import { useAuth } from '@/composables/useAuth';
import { type MessageSchema } from '@/i18n';
// import { useEnvStore } from '@/stores/envStore';
import Button from 'primevue/button';
import Message from 'primevue/message';
import { useI18n } from 'vue-i18n';
// import { useRouter } from 'vue-router';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
// const router = useRouter();
const { logout, isFetching } = useAuth();
// const envStore = useEnvStore();

async function handleLogout() {
  await logout();
}

// function handleCreateRestaurant() {
//   // Redirect to registration with flag to create new restaurant
//   router.push({ name: 'validate-restaurant' });
// }

function handleContactSupport() {
  // Open email or support page
  window.location.href = `mailto:support@gastronomia.ai?subject=${encodeURIComponent(t('noRestaurant.title'))}`;
}

// Translation to add :
// {
//   "errors": {
//     "noRestaurant": "Vous n'êtes associé à aucun restaurant",
//     "registrationIncomplete": "Veuillez d'abord compléter votre inscription"
//   },
//   "noRestaurant": {
//     "title": "Aucun Restaurant Trouvé",
//     "description": "Votre compte n'est associé à aucun restaurant. Cela peut se produire si :",
//     "reasons": {
//       "removed": "Vous avez été retiré de tous les restaurants",
//       "deleted": "Le(s) restaurant(s) dont vous faisiez partie ont été supprimés",
//       "invitation": "Votre lien d'invitation a expiré ou été invalidé"
//     },
//     "whatToDo": "Que pouvez-vous faire ?",
//     "actions": {
//       "contact": "Contactez votre administrateur de restaurant pour une nouvelle invitation",
//       "create": "Créer un nouveau compte restaurant",
//       "logout": "Se déconnecter et utiliser un autre compte"
//     },
//     "buttons": {
//       "logout": "Se Déconnecter",
//       "createRestaurant": "Créer un Nouveau Restaurant",
//       "contactSupport": "Contacter le Support"
//     }
//   }
// }
</script>

<template>
  <!-- <main class="mx-auto mt-10 max-w-2xl px-4">
    <div class="flex flex-col gap-6"> -->
  <!-- Header -->
  <!-- <div class="text-center">
        <div class="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
          <i class="pi pi-building text-4xl text-red-600"></i>
        </div>
        <h1 class="mb-2 text-2xl font-bold">{{ t('noRestaurant.title') }}</h1>
      </div> -->

  <!-- Info Message -->
  <!-- <Message severity="warn" :closable="false">
        {{ t('noRestaurant.description') }}
      </Message> -->

  <!-- Reasons -->
  <!-- <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
        <ul class="list-inside list-disc space-y-2 text-sm">
          <li>{{ t('noRestaurant.reasons.removed') }}</li>
          <li>{{ t('noRestaurant.reasons.deleted') }}</li>
          <li>{{ t('noRestaurant.reasons.invitation') }}</li>
        </ul>
      </div> -->

  <!-- What to do section -->
  <!-- <div>
        <h2 class="mb-3 font-semibold">{{ t('noRestaurant.whatToDo') }}</h2>
        <div class="space-y-3 rounded-lg border border-gray-200 bg-white p-4">
          <div class="flex items-start gap-3">
            <i class="pi pi-envelope mt-1 text-primary-600"></i>
            <p class="text-sm">{{ t('noRestaurant.actions.contact') }}</p>
          </div>
          <div class="flex items-start gap-3">
            <i class="pi pi-plus-circle mt-1 text-primary-600"></i>
            <p class="text-sm">{{ t('noRestaurant.actions.create') }}</p>
          </div>
          <div class="flex items-start gap-3">
            <i class="pi pi-sign-out mt-1 text-primary-600"></i>
            <p class="text-sm">{{ t('noRestaurant.actions.logout') }}</p>
          </div>
        </div>
      </div> -->

  <!-- Action Buttons -->
  <!-- <div class="flex flex-col gap-3">
        <Button :label="t('noRestaurant.buttons.createRestaurant')" icon="pi pi-plus" class="w-full"
          @click="handleCreateRestaurant" />
        <Button :label="t('noRestaurant.buttons.contactSupport')" icon="pi pi-envelope" severity="secondary" outlined
          class="w-full" @click="handleContactSupport" />
        <Button :label="t('noRestaurant.buttons.logout')" icon="pi pi-sign-out" severity="danger" outlined
          class="w-full" :loading="isFetching" @click="handleLogout" />
      </div>
    </div>
  </main> -->
  <main class="mx-auto mt-10 max-w-2xl px-4">
    <div class="flex flex-col gap-6">
      <!-- Header -->
      <div class="text-center">
        <div class="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
          <i class="pi pi-building text-4xl text-red-600"></i>
        </div>
        <h1 class="mb-2 font-bold text-2xl">No Restaurant Found</h1>
      </div>

      <!-- Info Message -->
      <Message severity="warn" :closable="false"> Your account is not associated with any restaurant. This can happen if: </Message>

      <!-- Reasons -->
      <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
        <ul class="list-inside list-disc space-y-2 text-sm">
          <li>You have been removed from all restaurants</li>
          <li>The restaurant(s) you were part of have been deleted</li>
          <li>Your invitation link has expired or been invalidated</li>
        </ul>
      </div>

      <!-- What to do section -->
      <div>
        <h2 class="mb-3 font-semibold">What can you do?</h2>
        <div class="space-y-3 rounded-lg border border-gray-200 bg-white p-4">
          <div class="flex items-start gap-3">
            <i class="pi pi-envelope mt-1 text-primary-600"></i>
            <p class="text-sm">Contact your restaurant administrator for a new invitation</p>
          </div>
          <div class="flex items-start gap-3">
            <i class="pi pi-plus-circle mt-1 text-primary-600"></i>
            <p class="text-sm">Create a new restaurant account</p>
          </div>
          <div class="flex items-start gap-3">
            <i class="pi pi-sign-out mt-1 text-primary-600"></i>
            <p class="text-sm">Log out and use another account</p>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-col gap-3">
        <!-- <Button label="Create New Restaurant" icon="pi pi-plus" class="w-full" @click="handleCreateRestaurant" /> -->
        <Button label="Contact Support" icon="pi pi-envelope" severity="secondary" outlined class="w-full" @click="handleContactSupport" />
        <Button label="Logout" icon="pi pi-sign-out" severity="danger" outlined class="w-full" :loading="isFetching" @click="handleLogout" />
      </div>
    </div>
  </main>
</template>
